import { uploadFile } from "../../../config/firebase";

const handleUpload = async (file, useSecondary = false) => {
  if (!file) {
    return { status: "failed", fileUrl: null };
  }

  try {
    const filePath = `uploads/${Date.now()}_${file.name}`;
    const fileUrl = await uploadFile(file, filePath, useSecondary);
    return { status: "success", fileUrl };
  } catch (error) {
    console.error("Upload Error:", error);
    return { status: "failed", fileUrl: null };
  }
};

export default handleUpload;
